import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { MapAuthorsState } from './mapAuthors.types';
import { addMapAuthor, deleteMapAuthor, getMapAuthors, updateMapAuthor } from './mapAuthors.thunks';

export const getMapAuthorsReducer = (builder: ActionReducerMapBuilder<MapAuthorsState>): void => {
  builder
    .addCase(getMapAuthors.pending, (state, action) => {
      const { mapId } = action.meta.arg;
      state.loading[mapId] = 'pending';
      state.error = null;
    })
    .addCase(getMapAuthors.fulfilled, (state, action) => {
      const { mapId, authors } = action.payload;
      state.data[mapId] = authors;
      state.loading[mapId] = 'succeeded';
    })
    .addCase(getMapAuthors.rejected, (state, action) => {
      const { mapId } = action.meta.arg;
      state.loading[mapId] = 'failed';
      state.error = action.payload as { name: string; message: string };
    });
};

export const addMapAuthorReducer = (builder: ActionReducerMapBuilder<MapAuthorsState>): void => {
  builder
    .addCase(addMapAuthor.pending, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'pending';
    })
    .addCase(addMapAuthor.fulfilled, (state, action) => {
      const { mapId, author } = action.payload;
      state.data[mapId] = [...(state.data[mapId] ?? []), author];
      state.mutationLoading[mapId] = 'succeeded';
    })
    .addCase(addMapAuthor.rejected, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'failed';
      state.error = action.payload as { name: string; message: string };
    });
};

export const updateMapAuthorReducer = (builder: ActionReducerMapBuilder<MapAuthorsState>): void => {
  builder
    .addCase(updateMapAuthor.pending, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'pending';
    })
    .addCase(updateMapAuthor.fulfilled, (state, action) => {
      const { mapId, author } = action.payload;
      const authors = state.data[mapId] ?? [];
      const NOT_FOUND_INDEX = -1;
      const index = authors.findIndex(existing => existing.id === author.id);
      if (index !== NOT_FOUND_INDEX) {
        authors[index] = author;
      }
      state.data[mapId] = authors;
      state.mutationLoading[mapId] = 'succeeded';
    })
    .addCase(updateMapAuthor.rejected, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'failed';
      state.error = action.payload as { name: string; message: string };
    });
};

export const deleteMapAuthorReducer = (builder: ActionReducerMapBuilder<MapAuthorsState>): void => {
  builder
    .addCase(deleteMapAuthor.pending, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'pending';
    })
    .addCase(deleteMapAuthor.fulfilled, (state, action) => {
      const { mapId, authorId } = action.payload;
      state.data[mapId] = (state.data[mapId] ?? []).filter(author => author.id !== authorId);
      state.mutationLoading[mapId] = 'succeeded';
    })
    .addCase(deleteMapAuthor.rejected, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'failed';
      state.error = action.payload as { name: string; message: string };
    });
};
